import { getUserIdSelector } from 'auth/selectors'
import { useUserAuthQuery } from 'auth/hooks'

export function useUserIdQuery() {
  return useUserAuthQuery(undefined, {
    select: getUserIdSelector,
  })
}
